package ui.login

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*
import tools.*
import ui.*

@VM
class LoginVM : NavigationViewModel() {

    private lateinit var scopeUI: LoginScope

    var name by mutableStateOf(TextFieldValue())
    var pass by mutableStateOf(TextFieldValue())
    var showPass by mutableStateOf(false)
    var error by mutableStateOf(true)

    var state by mutableDataState<Unit>()
        private set


    sealed interface Action {
        data class Login(val onPasswordChange: () -> Unit) : Action
        data class ChangePassword(val pass: String) : Action
        companion object {

            @Composable
            fun rememberAction(vm: LoginVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is Login -> vm.login(act)
                            is ChangePassword -> vm.changePass(act.pass)
                        }
                    }
                }
            }
        }
    }

    private lateinit var lastUser: Io.User

    private fun changePass(pass: String) {
        scope.launch {
            runCatching {
                Repository.api.user.passwordChange(lastUser.id, name.text.trim(), pass)
            }.onFailure {
                it.printStackTrace()
                error = true
            }.onSuccess {
                scopeUI.accountProvider.confirmAccount(lastUser, name.text.trim(), pass)
                scopeUI.nav.navTo_HomeUI(
                    args = scopeUI.args,
                    clearTop = true
                )
            }
        }
    }

    private fun login(act: Action.Login) {
        scope.launch {
            runCatching {
                Repository.api.user.login(name.text.trim(), pass.text.trim())
            }.onFailure {
                launch {
                    snackBarStateGlobal.showSnackbar(
                        it.message ?: Res.string.login__err.await(),
                        withDismissAction = true
                    )
                }
                error = true
            }.onSuccess {
                if (pass.text.trim() == "123456") {
                    lastUser = it
                    act.onPasswordChange()
                } else {
                    scopeUI.accountProvider.confirmAccount(it, name.text.trim(), pass.text.trim())
                    scopeUI.nav.navTo_HomeUI(
                        args = scopeUI.args,
                        clearTop = true
                    )
                }
            }
        }
    }


    fun init(scopeUI: LoginScope) {
        state = DataState.Idle()
        this.scopeUI = scopeUI
    }

    override fun onRelease() {
        state = DataState.Idle()
        name = TextFieldValue()
        pass = TextFieldValue()
    }

}
